import React from 'react';
import {Box, Typography} from '@mui/material';
import {t} from '../../themes/statamicTokens';

const EMPTY = '—';

const DataRow = ({label, value, hideWhenEmpty = false, children}) => {
    const resolved = children ?? value;
    const isEmpty =
        resolved === null ||
        resolved === undefined ||
        resolved === '' ||
        (typeof resolved === 'string' && resolved.trim() === '');

    if (hideWhenEmpty && isEmpty) return null;

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.25, py: 1}}>
            <Typography
                sx={{
                    fontSize: `${t.type.caption.size}px`,
                    color: t.color.text.secondary,
                    fontWeight: 500,
                }}
            >
                {label}
            </Typography>
            {isEmpty ? (
                <Typography sx={{fontSize: `${t.type.body.size}px`, color: t.color.text.muted}}>
                    {EMPTY}
                </Typography>
            ) : typeof resolved === 'string' || typeof resolved === 'number' ? (
                <Typography
                    sx={{
                        fontSize: `${t.type.body.size}px`,
                        color: t.color.text.primary,
                        wordBreak: 'break-word',
                    }}
                >
                    {resolved}
                </Typography>
            ) : (
                <Box sx={{fontSize: `${t.type.body.size}px`, color: t.color.text.primary}}>
                    {resolved}
                </Box>
            )}
        </Box>
    );
};

export default DataRow;
